module.exports = __webpack_public_path__ + "static/media/map-pin.73177f02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/map-pin.svg
// module id = 833
// module chunks = 21